import { AppModals, useAppModal } from '@/context/ModalProvider'
import { Button, ButtonProps, Flex, Text } from '@chakra-ui/react'
import { MdLibraryBooks } from 'react-icons/md'
import { GameRules } from 'types/types'
import { useTranslation } from 'next-i18next/pages'

export const RulesButton = ({
  game,
  compact = false,
  styles,
}: {
  game: GameRules
  compact?: boolean
  styles?: ButtonProps
}) => {
  const modal = useAppModal()
  const { t } = useTranslation()

  const handleOpenRulesModal = (e: any) => {
    e.stopPropagation()
    modal.openModalNew(AppModals.GameRules, { game })
  }

  return (
    <Button
      onClick={handleOpenRulesModal}
      bg={'transparent'}
      _hover={{
        bg: 'whiteAlpha.100',
      }}
      border={'1px solid'}
      borderColor={'whiteAlpha.100'}
      alignSelf={'stretch'}
      rounded={'xl'}
      h={'auto'}
      flexShrink={0}
      px={{ base: compact ? 4 : 6, sm: 6 }}
      py={3}
      {...styles}
    >
      <Flex gap={2}>
        <MdLibraryBooks />
        <Text display={{ base: compact ? 'none' : 'block', md: 'block' }}>{t('common.rules-btn')}</Text>
      </Flex>
    </Button>
  )
}
